/**
 * Sign-in recovery copy: boot strip failure + Banned-by-you error states. Merged into every catalog by translations.js.
 */
const signInRecoveryI18n = {
  en: {
    'signInRecovery.stripFailed': "We couldn't finish signing you in.",
    'signInRecovery.signInAgain': 'Sign in again',
    'ellaBans.error.auth': 'Your sign-in needs refreshing. Please sign in again, then try once more.',
    'ellaBans.error.network': "Can't reach Maestro right now. Check your connection and try again.",
    'ellaBans.error.generic': "Something went wrong with your bans. Please try again.",
    'ellaBans.retry': 'Try again',
  },
  es: {
    'signInRecovery.stripFailed': 'No pudimos terminar de iniciar tu sesión.',
    'signInRecovery.signInAgain': 'Iniciar sesión de nuevo',
    'ellaBans.error.auth': 'Tu inicio de sesión necesita renovarse. Inicia sesión de nuevo e inténtalo otra vez.',
    'ellaBans.error.network': 'No se puede conectar con Maestro ahora. Revisa tu conexión e inténtalo de nuevo.',
    'ellaBans.error.generic': 'Algo salió mal con tus prohibiciones. Inténtalo de nuevo.',
    'ellaBans.retry': 'Reintentar',
  },
  fr: {
    'signInRecovery.stripFailed': "Nous n'avons pas pu terminer votre connexion.",
    'signInRecovery.signInAgain': 'Se reconnecter',
    'ellaBans.error.auth': 'Votre connexion doit être renouvelée. Reconnectez-vous puis réessayez.',
    'ellaBans.error.network': 'Impossible de joindre Maestro pour le moment. Vérifiez votre connexion et réessayez.',
    'ellaBans.error.generic': "Un problème est survenu avec vos interdictions. Veuillez réessayer.",
    'ellaBans.retry': 'Réessayer',
  },
  de: {
    'signInRecovery.stripFailed': 'Wir konnten die Anmeldung nicht abschließen.',
    'signInRecovery.signInAgain': 'Erneut anmelden',
    'ellaBans.error.auth': 'Deine Anmeldung muss erneuert werden. Bitte melde dich erneut an und versuche es noch einmal.',
    'ellaBans.error.network': 'Maestro ist gerade nicht erreichbar. Prüfe deine Verbindung und versuche es erneut.',
    'ellaBans.error.generic': 'Bei deinen Sperren ist etwas schiefgelaufen. Bitte versuche es erneut.',
    'ellaBans.retry': 'Erneut versuchen',
  },
  it: {
    'signInRecovery.stripFailed': 'Non siamo riusciti a completare il tuo accesso.',
    'signInRecovery.signInAgain': 'Accedi di nuovo',
    'ellaBans.error.auth': 'Il tuo accesso deve essere rinnovato. Accedi di nuovo e riprova.',
    'ellaBans.error.network': 'Impossibile raggiungere Maestro in questo momento. Controlla la connessione e riprova.',
    'ellaBans.error.generic': 'Qualcosa è andato storto con i tuoi blocchi. Riprova.',
    'ellaBans.retry': 'Riprova',
  },
  pt: {
    'signInRecovery.stripFailed': 'Não conseguimos concluir o seu login.',
    'signInRecovery.signInAgain': 'Entrar novamente',
    'ellaBans.error.auth': 'O seu login precisa ser renovado. Entre novamente e tente mais uma vez.',
    'ellaBans.error.network': 'Não foi possível conectar ao Maestro agora. Verifique a conexão e tente novamente.',
    'ellaBans.error.generic': 'Algo deu errado com os seus bloqueios. Tente novamente.',
    'ellaBans.retry': 'Tentar novamente',
  },
  ja: {
    'signInRecovery.stripFailed': 'サインインを完了できませんでした。',
    'signInRecovery.signInAgain': '再度サインイン',
    'ellaBans.error.auth': 'サインインの更新が必要です。もう一度サインインしてからお試しください。',
    'ellaBans.error.network': '現在Maestroに接続できません。接続を確認してもう一度お試しください。',
    'ellaBans.error.generic': '禁止リストで問題が発生しました。もう一度お試しください。',
    'ellaBans.retry': '再試行',
  },
  ko: {
    'signInRecovery.stripFailed': '로그인을 완료하지 못했습니다.',
    'signInRecovery.signInAgain': '다시 로그인',
    'ellaBans.error.auth': '로그인을 갱신해야 합니다. 다시 로그인한 후 다시 시도해 주세요.',
    'ellaBans.error.network': '지금은 Maestro에 연결할 수 없습니다. 연결을 확인하고 다시 시도해 주세요.',
    'ellaBans.error.generic': '차단 목록에 문제가 발생했습니다. 다시 시도해 주세요.',
    'ellaBans.retry': '다시 시도',
  },
  zh: {
    'signInRecovery.stripFailed': '我们无法完成登录。',
    'signInRecovery.signInAgain': '重新登录',
    'ellaBans.error.auth': '您的登录需要刷新。请重新登录后再试一次。',
    'ellaBans.error.network': '目前无法连接到 Maestro。请检查网络连接后重试。',
    'ellaBans.error.generic': '您的屏蔽列表出了点问题。请重试。',
    'ellaBans.retry': '重试',
  },
  nl: {
    'signInRecovery.stripFailed': 'We konden het inloggen niet voltooien.',
    'signInRecovery.signInAgain': 'Opnieuw inloggen',
    'ellaBans.error.auth': 'Je aanmelding moet worden vernieuwd. Meld je opnieuw aan en probeer het nog eens.',
    'ellaBans.error.network': 'Maestro is nu niet bereikbaar. Controleer je verbinding en probeer het opnieuw.',
    'ellaBans.error.generic': 'Er ging iets mis met je geblokkeerde items. Probeer het opnieuw.',
    'ellaBans.retry': 'Opnieuw proberen',
  },
  sv: {
    'signInRecovery.stripFailed': 'Vi kunde inte slutföra inloggningen.',
    'signInRecovery.signInAgain': 'Logga in igen',
    'ellaBans.error.auth': 'Din inloggning behöver förnyas. Logga in igen och försök sedan en gång till.',
    'ellaBans.error.network': 'Det går inte att nå Maestro just nu. Kontrollera anslutningen och försök igen.',
    'ellaBans.error.generic': 'Något gick fel med dina blockeringar. Försök igen.',
    'ellaBans.retry': 'Försök igen',
  },
};

export default signInRecoveryI18n;
